module.exports = __webpack_public_path__ + "img/twitter_yellow.a41cfeee.svg";